import "./App.scss";
import "./assets/scss/styles.scss";
import { useAuth0 } from "@auth0/auth0-react";
import RootRouter from "./components/layout/RootRouter/RootRouterContainer";
import Loader from "./components/usercontrols/loader/loader";

const App = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <Loader />;
  }

  return <RootRouter />;
};

export default App;
